import { apiClient } from './client';

export type DataQaRole = 'user' | 'assistant';

export interface DataQaMessage {
  role: DataQaRole;
  content: string;
}

export type QueryRow = Record<string, unknown>;

export interface ExecutedQuery {
  sql: string;
  purpose: string;
  rowCount: number | null;
  truncated: boolean;
  durationMs: number;
  error: string | null;
  columns: string[];
  // Fylls bara för den sista lyckade frågan i svaret och för frågor med diagram.
  rows: QueryRow[];
}

export type ChartType = 'bar' | 'line';

export interface ChartSpec {
  // Index i queries; raderna för den frågan skickas alltid med.
  queryIndex: number;
  type: ChartType;
  x: string;
  y: string[];
  // Läsbara serienamn i samma ordning som y; saknas de visas kolumnnamnen.
  labels?: string[];
  title: string;
}

export interface DataQaAnswer {
  answer: string;
  queries: ExecutedQuery[];
  charts: ChartSpec[];
  model: string;
}

export const askDataQa = async (messages: DataQaMessage[]): Promise<DataQaAnswer> => {
  const { data } = await apiClient.post<DataQaAnswer>('/data-qa/ask', { messages });
  return data;
};
